import { getData, postData, putData, deleteData } from "../apiClient";

const BASE_URL = "swimming-pool";
const ModuleName = "Swimming Pool";

// get All
export const getSwimmingPoolWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const result = await getData(`${BASE_URL}/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error(`Get ${ModuleName} with pagination API error:`, error);
        return {
            success: false,
            ...error,
        };
    }
};

// get with id
export const getSwimmingPoolDataWithId = async (id) => {
    try {
        const result = await getData(`${BASE_URL}/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error(`Get ${ModuleName} data API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// create 
export const createSwimmingPool = async ({ data }) => {
    try {
        const result = await postData(`${BASE_URL}/create-swimming-pool/`, data);

        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(`${ModuleName} add API error:`, error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// delete
export const deleteSwimmingPool = async ({ id }) => {
    try {
        const result = await deleteData(`${BASE_URL}/delete-swimming-pool/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(`${ModuleName} delete API error:`, error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// update
export const updateSwimmingPool = async ({ id, data }) => {
    try {
        const result = await putData(`${BASE_URL}/update-swimming-pool/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(`${ModuleName} update API error:`, error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// get pool type
export const getPoolType = async () => {
    try {
        const result = await getData(`${BASE_URL}/pool-type`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error(`Get Pool Type API error:`, error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};
